import React from 'react';
import { Box, Typography, useTheme } from '@ublend-npm/aulaui-core';

const STRINGS = {
  title: 'No mail',
  subtitle: "New mail will appear here when they're arrived.",
};

const OutlookEmptyState = () => {
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        alignSelf: 'stretch',
        display: 'flex',
        width: '100%',
        minHeight: '100%',
      }}
      role="status"
      aria-label="No upcoming assignments empty state"
    >
      <Box
        sx={{
          flex: 1,
          width: '100%',
          minHeight: '100%',
          bgcolor: palette.background.default,
          borderRadius: '12px',
          px: { xs: 2, sm: 3 },
          py: 1.5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Typography
          color="text.primary"
          sx={{
            fontFamily: (theme) => theme.typography.fontFamily,
            fontWeight: 'regular',
            fontStyle: 'normal',
            fontSize: '1rem',
            lineHeight: '175%',
            letterSpacing: '0.15px',
            textAlign: 'center',
          }}
        >
          {STRINGS.title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          mt={0.75}
          sx={{
            fontFamily: (theme) => theme.typography.fontFamily,
            fontWeight: 'regular',
            fontStyle: 'normal',
            fontSize: '0.875rem',
            lineHeight: '143%',
            letterSpacing: '0.17px',
            textAlign: 'center',
          }}
        >
          {STRINGS.subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default OutlookEmptyState;
